module.exports = __webpack_public_path__ + "img/Close.c4aaecf1.svg";